<template>
  <div>
    <h3 class="row mb-3 mt-3">単語帳バッヂ ({{ defaultListBadge.length }})</h3>
    <v-row>
      <v-text-field
        v-model="keyword"
        hide-details
        dense
        @keyup.enter="search"
        class="text-field-search mr-10"
        outlined
      />
      <v-btn color="primary" class="font-weight-black" @click="search">{{
        $t("SEARCH")
      }}</v-btn>
      <v-spacer />
      <v-select
        class="select-record"
        hide-details
        :items="recordsPage"
        v-model="pagination.maxResultCount"
        dense
        outlined
      />

      <BadgeAdd @resetList="handleResetList" />
    </v-row>
    <v-row>
      <v-layout child-flex>
        <v-data-iterator
          :items-per-page.sync="pagination.maxResultCount"
          :page="pagination.page"
          :key="keyListBadge"
          :loading="loadingList"
          :items="listBadge"
          hide-default-footer
        >
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.Id"
                cols="2"
                class="card-list"
              >
                <v-card color="#f5f5f5">
                  <v-card-text class="align-start py-3">
                    <div
                      class="font-weight-bold text-truncate"
                      style="max-width: 182px"
                    >
                      {{ item.name }}
                    </div>
                    <div class="row pa-0 ma-0">
                      <div class="icon-trash">
                        <!-- edit legal information-->
                        <BadgeUpdate
                          :item="item"
                          @resetList="handleResetList"
                        />
                        <BadgeDelete
                          :item="item"
                          @resetList="handleResetList"
                        />
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <template v-slot:loading>
            <div class="text-center mt-5">読み込み中。。。待ってください。</div>
          </template>
          <template v-slot:no-data>
            <div class="text-center mt-5">データがありません。</div>
          </template>
        </v-data-iterator>
      </v-layout>
    </v-row>
    <BasePagination
      v-if="listBadge.length > 0"
      :pageCount="listBadge.length"
      :pageSize="pagination.maxResultCount"
      @changePage="changePage"
    />
  </div>
</template>
<script>
import mixin from "@/mixin";
import BasePagination from "@/components/Pagination/BasePagination";
import { getListBadge } from "@/api/Badge.api";
import BadgeDelete from "./WordBookBadgeDelete";
import BadgeAdd from "./WordBookBadgeAdd";
import BadgeUpdate from "./WordBookBadgeUpdate";
export default {
  mixins: [mixin.App],
  components: {
    BasePagination,
    BadgeDelete,
    BadgeAdd,
    BadgeUpdate,
  },
  data() {
    return {
      listBadge: [],
      defaultListBadge: [],
      keyListBadge: 0,
      keyword: "",
      loadingList: false,
    };
  },
  async mounted() {
    await this.handleGetListBadge();
  },
  methods: {
    async handleGetListBadge() {
      this.keyListBadge++;
      let params = {
        keyword: "",
      };
      this.loadingList = true;
      await getListBadge(params)
        .then((data) => {
          this.defaultListBadge = data.result;
          this.listBadge = data.result;
          this.pagination.pageCount = data.totalCount;
          this.loadingList = false;
        })
        .catch((error) => {
          this.loadingList = false;
          console.log(error);
        });
    },
    async search() {
      await this.handleGetListBadge();
      const { keyword } = this;
      let keywordSearch = keyword.toLowerCase();
      this.listBadge = this.defaultListBadge.filter(
        (item) => item.name.toLowerCase().search(keywordSearch) > -1
      );
      this.pagination.pageCount = this.listBadge.length;
    },
    async handleResetList() {
      if (this.keyword !== "") return (this.keyword = "");
      await this.handleGetListBadge();
    },
    changePage(value) {
      this.pagination.page = value;
    },
  },
};
</script>
<style scoped>
.mt-1 {
  margin-top: 0 !important;
}
.btn-search-tab {
  margin-left: 15px;
}

.badge-card {
  width: 100%;
}
</style>